module.exports = __webpack_public_path__ + "static/media/019-fast-delivery.e2e791dc.svg";